import moment from "moment"

export const getDate = () => moment().format("YYYY-MM-DD")
